<template>
	<div class="position_center md-layout-item register_personal margin_horizontal">
		<div class="pageTitle">
			<span class="md-title"><i class="fa fa-envelope" aria-hidden="true"></i> {{ $t("admin.companyData.title") }}</span>
		</div>
		<p class="tertiary_color">
			{{ $t("admin.companyData.description") }}
		</p>
		<div>
			<form class="form-horizontal" action style="width:520px;margin:0 auto;">
				<div class="md-layout">
					<div class="md-layout-item">
						<md-field>
							<label>{{ $t("common.companyName") }}</label>
							<md-input
								:value="form.name"
								required
								disabled
							></md-input>
						</md-field>
						<md-field>
							<label>{{ $t("Completion.Company.email") }}</label>
							<md-input
								:value="form.email"
								required
								disabled
							></md-input>
						</md-field>
						<CountrySelect
							v-on:input="onSelectCountry"
							:labelText="$t('common.country')"
							:value="form.address.country"
							disabled
							required
						></CountrySelect>
						<md-field>
							<label>{{ $t("Completion.Company.Street") }}</label>
							<md-input
								:value="form.address.street"
								required
								disabled
							></md-input>
						</md-field>
						<md-field>
							<label>{{ $t("Completion.Company.AddressAddon") }}</label>
							<md-input
								:value="form.address.addressAddon"
								disabled
							></md-input>
						</md-field>
						<md-field>
							<label>{{ $t("common.postcode") }}</label>
							<md-input
								:value="form.address.postCode"
								required
								disabled
							></md-input>
						</md-field>
						<md-field>
							<label>{{ $t("common.city") }}</label>
							<md-input
								:value="form.address.city"
								required
								disabled
							></md-input>
						</md-field>
						<LegalFormSelect
							:country="form.address.country"
							:labelText="$t('signUp.componyInfo.legalForm')"
							:value="form.legalStructure"
							:company-type="enumDef.companyType.TraderCompany"
							required
							disabled
						></LegalFormSelect>
						<RegisterSelect
							:country="form.address.country"
							:labelText="$t('common.registrationAuthority')"
							:value="form.companyRegisterId"
							required
							disabled
							ref="registerSelect"
						></RegisterSelect>
						<md-field>
							<label>{{ $t("Completion.Company.RegisterNo") }}</label>
							<md-input
								:value="form.registrationNum"
								required
								disabled
							></md-input>
						</md-field>
						<md-field>
							<label>{{ $t("common.industry") }}</label>
							<md-input :value="form.industryNaceCode ? $t(`common.industry.${form.industryNaceCode}`) : ''"
									  disabled
							></md-input>
						</md-field>
						<md-field>
							<label>{{ $t("common.vatId") }}</label>
							<md-input
								:value="form.taxNum"
								required
								disabled
							></md-input>
						</md-field>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import {companyProfileApi} from "@/common/api/companyProfileApi";

import CountrySelect from "@/components/templates/select/CountrySelect.vue";
import LegalFormSelect from "@/components/templates/select/LegalFormSelect.vue";
import RegisterSelect from "@/components/templates/select/RegisterSelect.vue";
import {enumDef} from "@/common/enumDefs";

export default {
	components: {
		CountrySelect,
		LegalFormSelect,
		RegisterSelect
	},
	data() {
		return {
			enumDef: enumDef,
			form: {
				address: {
					addressAddon: "",
					city: "",
					country: "",
					id: "",
					postCode: "",
					street: ""
				},
				id: null,
				name: "",
				email: "",
				country: "",
				legalStructure: "",
				companyRegisterId: "",
				registrationNum: "",
				industryNaceCode: "",
				taxNum: "",
				taxId: ""
			}
		};
	},
	beforeMount() {
		this.loadData();
	},
	methods: {
		loadData() {
			companyProfileApi.inspection.getData()
				.then(res => {
					this.form = { ...this.form, ...res };
				})
				.catch(this.toast);
		}
	}
};
</script>